import React, { useState } from "react";
import {
  NodeWrapper,
  EmployeeCard,
  EmployeeAvatar,
  EmployeeInfo,
  EmployeeName,
  EmployeeRole,
  EmployeeEmail,
  CollapseButton,
  ChildrenContainer,
  ChildNode,
  Icon,
  EmployeeCount,
  EmployeeCount2,
  StatusLink,
  ButtonAction,
} from "./evaluationOrgChart.styled";
import { useTranslation } from "react-i18next";
import { EVAL_STATUS } from "../../../../constants";
import { useNavigate } from "react-router-dom";
import PATHS from "../../../../constants/paths";
import * as EvaluationService from "../../../../services/EvaluationServices";

import * as XLSX from "xlsx";

const OrgNode = ({
  node,
  onShowDetail,
  isManager = false,
  isRoot = false,
  level = 0,
  onlyOrgChart,
}) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);
  const hasChildren = node.children && node.children.length > 0;
  const navigate = useNavigate();

  const getInitials = (name, surname) => {
    const firstInitial = name ? name.charAt(0).toUpperCase() : "";
    const lastInitial = surname ? surname.charAt(0).toUpperCase() : "";
    return `${firstInitial}${lastInitial}`;
  };

  const getTotalEmployees = (node) => {
    if (!node.children || node.children.length === 0) {
      return 0;
    }

    let total = node.children.length; // Empleados directos

    // Sumar recursivamente los empleados de cada hijo
    node.children.forEach((child) => {
      total += getTotalEmployees(child);
    });

    return total;
  };

  const toggleExpand = (e) => {
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  const exportToExcel = async (uuid) => {
    // const filter = {
    //   filters: filters,
    //   sort: "date",
    // };
    EvaluationService.listToExportEmails(uuid).then((result) => {
      console.log(result);
      const data = result.map((item) => {
        let fila;
        fila = {
          A: item.email,
        };
        return fila;
      });

      const headers = {
        A: "Email",
      };

      data.unshift(headers);

      const filename = `Emails_Empleados`;
      const sheetName = "Listado de Emails";
      var ws = XLSX.utils.json_to_sheet(data, {
        header: ["A"],
        skipHeader: true,
        UTC: true,
        dateNF: "dd-mm-yyyy hh:mm;@",
      });

      // dateNF:'mm/dd/yyyy;@',cellDates:true, raw: true}
      const wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Listado de sesiones",
        Subject: "Exportación de sesiones",
        Author: "Assista",
        CreatedDate: new Date(),
      };
      wb.SheetNames.push(sheetName);
      wb.Sheets[sheetName] = ws;
      XLSX.writeFile(wb, filename + ".xlsx", {
        bookType: "xlsx",
        type: "binary",
      });
    });
  };

  return (
    <NodeWrapper $level={level}>
      <EmployeeCard
        $isManager={isRoot}
        $isEvaluator={!isRoot && hasChildren}
        $hasChildren={hasChildren}
        onClick={hasChildren ? toggleExpand : undefined}
      >
        <EmployeeAvatar
          $isManager={isRoot}
          $isEvaluator={!isRoot && hasChildren}
        >
          {getInitials(node.name, node.surname)}
        </EmployeeAvatar>

        <EmployeeInfo>
          <EmployeeName>
            {node.name} {node.surname}
          </EmployeeName>
          <EmployeeRole
            $isManager={isRoot}
            $isEvaluator={!isRoot && hasChildren}
          >
            {!onlyOrgChart ? (
              <>
                {node.evaluation && node.evaluation.length > 0 ? (
                  <>
                    <StatusLink>
                      <Icon
                        className={
                          EVAL_STATUS.find(
                            (status) =>
                              status.code === node.evaluation[0].status
                          )?.icon
                        }
                        $color={
                          EVAL_STATUS.find(
                            (status) =>
                              status.code === node.evaluation[0].status
                          )?.color
                        }
                      ></Icon>
                      {t(
                        EVAL_STATUS.find(
                          (status) => status.code === node.evaluation[0].status
                        )?.label || t("forms.evaluation.status.pending")
                      )}{" "}
                      {/* <Icon className="fa-solid fa-arrow-right"></Icon> */}
                    </StatusLink>
                    <ButtonAction
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(
                          PATHS.VIEW_EVALUATION.replace(
                            ":uuid",
                            node.evaluation[0].uuid
                          )
                        );
                      }}
                    >
                      <i className="fa-solid fa-arrow-right"></i>
                    </ButtonAction>
                  </>
                ) : (
                  <span>{t("forms.consult.orgChart.noEvaluation")}</span>
                )}
              </>
            ) : (
              <>
                {node.children && node.children.length > 0 && (
                  <ButtonAction
                    onClick={(e) => {
                      e.stopPropagation();
                      if (node.email === "joseluisdeprado@deprado.eu") {
                        exportToExcel(node.uuid);
                      } else {
                        exportToExcel(node.userUuid);
                      }
                    }}
                  >
                    {t("forms.consult.orgChart.exportEmails")}
                  </ButtonAction>
                )}
              </>
            )}
          </EmployeeRole>
          <EmployeeEmail>{node.email}</EmployeeEmail>
        </EmployeeInfo>

        {hasChildren && (
          <>
            {" "}
            <EmployeeCount2>
              {node.children.length}{" "}
              {node.children.length === 1
                ? t("forms.consult.orgChart.directEmployee")
                : t("forms.consult.orgChart.directEmployees")}
            </EmployeeCount2>
            <EmployeeCount>
              {getTotalEmployees(node)}{" "}
              {getTotalEmployees(node) === 1
                ? t("forms.consult.orgChart.employee")
                : t("forms.consult.orgChart.employees")}
            </EmployeeCount>
          </>
        )}

        {hasChildren && (
          <CollapseButton onClick={toggleExpand}>
            <i
              className={`fa-solid fa-chevron-${isExpanded ? "up" : "down"}`}
            ></i>
          </CollapseButton>
        )}
      </EmployeeCard>

      {hasChildren && isExpanded && (
        <ChildrenContainer>
          {node.children.map((child, index) => (
            <ChildNode
              key={child.uuid || child.userUuid || `${child.email}-${index}`}
            >
              <OrgNode
                node={child}
                onShowDetail={onShowDetail}
                isManager={!isRoot && hasChildren}
                level={level + 1}
                onlyOrgChart={onlyOrgChart}
              />
            </ChildNode>
          ))}
        </ChildrenContainer>
      )}
    </NodeWrapper>
  );
};

export default OrgNode;
